import { observer } from 'mobx-react-lite';
import * as React from 'react';
import loc from 'owa-localize';
import { GetStartedListPosition } from '../enums/GetStartedListPosition';
import { GetStartedHeaderProperty } from '../interfaces/GetStartedHeaderProperty';
import { ProgressIndicator } from 'office-ui-fabric-react/lib/ProgressIndicator';
import { getCompletionPercentage } from '../selectors/getCompletionPercentage';
import { ControlIcons } from 'owa-control-icons';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { logUsage } from 'owa-analytics';

import {
    getStarted_ListView_Title_Text,
    getStarted_ListView_CloseButton_Text,
    getStarted_ListView_ExpandButton_Text,
    getStarted_ListView_CollapseButton_Text,
} from '../getStarted.locstring.json';

const classNames = require('classnames');
const styles = require('./GetStartedHeader.scss');
const progressStyles = require('./Progress.scss');

export default observer(function GetStartedHeader(props: GetStartedHeaderProperty) {
    const [collapsed, setCollapsed] = React.useState<boolean>(
        props.position === GetStartedListPosition.QuickOption
    );
    const onCloseButtonClicked = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();
        logUsage('CloseButtonInGetStartedHeaderClicked', [props.position], { isCore: true });
        if (props.onCloseButtonClicked) {
            props.onCloseButtonClicked(evt);
        }
    };
    const onChevronButtonClicked = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();
        logUsage('ChevronButtonInGetStartedHeaderClicked', [props.position], { isCore: true });
        setCollapsed(!collapsed);
        if (props.onChevronButtonClicked) {
            props.onChevronButtonClicked(evt);
        }
    };
    const completionPercentage = getCompletionPercentage();
    return (
        <div
            className={classNames(
                styles.headerWrapper,
                collapsed ? undefined : styles.headerWrapperPaddingExpanded,
                props.position === GetStartedListPosition.QuickOption
                    ? styles.headerWrapperMarginQuickOption
                    : styles.headerWrapperMarginListView
            )}>
            <div className={styles.headerTitleText}>{loc(getStarted_ListView_Title_Text)}</div>
            <div className={classNames(progressStyles.progress, styles.headerProgressBarWrapper)}>
                <ProgressIndicator
                    percentComplete={completionPercentage}
                    className={styles.headerProgressBar}
                />
            </div>
            {props.position === GetStartedListPosition.ListView && (
                <IconButton
                    title={loc(getStarted_ListView_CloseButton_Text)}
                    ariaLabel={loc(getStarted_ListView_CloseButton_Text)}
                    className={styles.headerCloseButton}
                    iconProps={{ iconName: ControlIcons.ChromeClose }}
                    onClick={onCloseButtonClicked}
                />
            )}
            {props.position === GetStartedListPosition.QuickOption && (
                <IconButton
                    title={
                        collapsed
                            ? loc(getStarted_ListView_ExpandButton_Text)
                            : loc(getStarted_ListView_CollapseButton_Text)
                    }
                    ariaLabel={
                        collapsed
                            ? loc(getStarted_ListView_ExpandButton_Text)
                            : loc(getStarted_ListView_CollapseButton_Text)
                    }
                    className={styles.headerChevronButton}
                    iconProps={{
                        iconName: collapsed ? ControlIcons.ChevronDown : ControlIcons.ChevronUp,
                    }}
                    onClick={onChevronButtonClicked}
                />
            )}
        </div>
    );
});
